import React from 'react';
import './Sub-services.css'; // Importa los estilos CSS para este componente
import acompañamiento from './assets/acompañamiento.png';
const AcompanamientoTecnicoContent = () => {
  return (
    <div className="containerSer">
      <h2>Acompañamiento Técnico y Revisiones Eléctricas</h2>
      <p>
        Consiste en brindar asesoría experta y supervisión técnica durante la ejecución de instalaciones eléctricas o sistemas solares, así como la revisión del estado y cumplimiento normativo de instalaciones ya existentes. Está dirigido a propietarios, contratistas, ingenieros o empresas que requieren respaldo profesional para garantizar la seguridad, eficiencia y conformidad de sus proyectos eléctricos según las normas vigentes.
      </p>
       <div className="image">
        <img src={acompañamiento} alt="Estudios tecnico y revisiones electricas" />
      </div>

      <p>
        Ofrecemos el servicio de acompañamiento técnico especializado y de revisiones eléctricas preventivas y correctivas para identificar los riesgos existentes, evaluar el estado actual además de respaldar tus proyectos eléctricos o fotovoltaicos, asegurando la correcta ejecución de las instalaciones desde el diseño hasta la puesta en marcha, adaptándose a las necesidades de cada cliente, dando cumplimiento con la normativa vigente; este servicio incluye: inspección técnica de instalaciones, verificación de cumplimiento normativo; evaluación de seguridad y eficiencia del sistema eléctrico, recomendaciones técnicas de mejoras o correcciones; asistencia en procesos de certificación eléctrica; acompañamiento en visitas técnicas o auditorías.
      </p>
      <h3>Beneficios clave:</h3>
      <ul>
        <li>Seguridad eléctrica para personas, bienes e instalaciones.</li>
        <li>Prevención de fallos, sobrecargas y riesgos eléctricos.</li>
        <li>Cumplimiento a las normativas aplicables.</li>
        <li>Respaldo técnico profesional durante todo el proceso.</li>
        <li>Tranquilidad al contar con asesoría confiable y experta.</li>
      </ul>
    </div>
  );
};

export default AcompanamientoTecnicoContent;
